import React from 'react';
import { Checkbox } from '@atlaskit/checkbox';
import { DisplayMode } from '../../RenderForm';
import { ChoiceQuestionStyles } from '../common/commonStyles';
import { ChoiceFieldWrapper, ChoicePlaceholder } from '../common/questionWrappers';
import { ViewOtherOption } from './ViewOtherOption';
export const ViewMultiChoice = ({
  id,
  value,
  options,
  hasOtherOption,
  otherOptionText,
  displayMode
}) => {
  // if the user has selected 'Other...' and provided a value we display that value. Otherwise we display 'Other...'
  const labels = value && value.map(item => item.label);
  if (labels && hasOtherOption && otherOptionText) {
    labels.push(otherOptionText);
    // the actual 'Other...' option will always be the last one in the array, we do not display this in view mode
    // it is the last one in case the user added their own option that is also called 'Other...'
    const lastIndex = labels.lastIndexOf('Other...');
    if (lastIndex !== -1) {
      labels.splice(lastIndex, 1);
    }
  }
  return /*#__PURE__*/React.createElement(ChoiceFieldWrapper, {
    isDisabled: true,
    isView: displayMode === DisplayMode.View
  }, options !== null && options !== void 0 && options.length ? /*#__PURE__*/React.createElement(ChoiceQuestionStyles, null, /*#__PURE__*/React.createElement("div", {
    id: id
  }, options.map(option => /*#__PURE__*/React.createElement(Checkbox, {
    name: id,
    key: option.value,
    value: option.value,
    label: option.label,
    isChecked: value === null || value === void 0 ? void 0 : value.includes(option),
    isDisabled: true
  })))) : /*#__PURE__*/React.createElement(ChoicePlaceholder, null), otherOptionText && /*#__PURE__*/React.createElement(ViewOtherOption, {
    dropdown: false,
    display: hasOtherOption,
    value: otherOptionText
  }));
};